import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import SellerLayout from './SellerLayout';

const SellerCouponManage = () => {

  const navigate = useNavigate();
  
  const [coupons,setCoupons] = useState([]);
  const [members,setMembers] = useState([]);
  const [shopName,setShopName] = useState('');

  const [form,setForm] = useState({
    coupon_name:'',
    discount_type:'amount',
    discount_value:'',
    min_order_price:'',
    start_date:'',
    end_date:''
  });

  const [keyword,setKeyword] = useState('');
  const [selectedCoupon,setSelectedCoupon] = useState('');

  const loadCoupons = () => {
    axios.get('/api/seller/coupon/list')
    .then(res=>{
      setCoupons(res.data.coupons || []);
      setShopName(res.data.shop_name || '');
    });
  };

  useEffect(()=>{
    loadCoupons();
  },[]);

  const createCoupon = async () => {

    await axios.post(
      '/api/seller/coupon/create',
      form
    );

    alert('쿠폰 생성 완료');

    loadCoupons();
  };

  const deleteCoupon = async (couponId) => {

    if(!window.confirm('삭제하시겠습니까?')){
      return;
    }
  
    await axios.post(
      '/api/seller/coupon/delete',
      {
        coupon_id: couponId
      }
    );
  
    alert('삭제 완료');
  
    loadCoupons();
  };

  const searchMember = async () => {

    const res = await axios.get(
      `/api/seller/member/search?keyword=${keyword}`
    );

    setMembers(res.data.members || []);
  };

  const issueCoupon = async (memberId) => {

    if(!selectedCoupon){
      alert('쿠폰 선택');
      return;
    }

    await axios.post(
      '/api/seller/coupon/issue',
      {
        member_id:memberId,
        coupon_id:selectedCoupon
      }
    );

    alert('지급 완료');
  };

  const issueAll = async () => {

    if(!selectedCoupon){
      alert('쿠폰 선택');
      return;
    }

    if(!window.confirm('전회원 지급?')){
      return;
    }

    await axios.post(
      '/api/seller/coupon/issue-all',
      {
        coupon_id:selectedCoupon
      }
    );

    alert('전회원 지급 완료');
  };

  return (
    <SellerLayout shopName={shopName}>
      <div className="container mt-4">
  
        <h3>쿠폰 생성</h3>
  
        <input
          className="form-control mb-2"
          placeholder="쿠폰명"
          onChange={e=>setForm({
            ...form,
            coupon_name:e.target.value
          })}
        />
  
        <select
          className="form-select mb-2"
          onChange={e=>setForm({
            ...form,
            discount_type:e.target.value
          })}
        >
          <option value="amount">금액할인</option>
          <option value="percent">퍼센트할인</option>
        </select>
  
        <input
          className="form-control mb-2"
          placeholder="할인값"
          onChange={e=>setForm({
            ...form,
            discount_value:e.target.value
          })}
        />
  
        <input
          className="form-control mb-2"
          placeholder="최소주문금액"
          onChange={e=>setForm({
            ...form,
            min_order_price:e.target.value
          })}
        />
  
        <input
          type="datetime-local"
          className="form-control mb-2"
          onChange={e=>setForm({
            ...form,
            start_date:e.target.value
          })}
        />
  
        <input
          type="datetime-local"
          className="form-control mb-3"
          onChange={e=>setForm({
            ...form,
            end_date:e.target.value
          })}
        />
  
        <button
          className="btn btn-primary"
          onClick={createCoupon}
        >
          쿠폰 생성
        </button>
  
        <hr />
  
        <h3 className="mb-3">생성된 쿠폰 목록</h3>
  
        <div className="table-responsive mb-4">
          <table className="table table-bordered table-hover">
            <thead className="table-light">
              <tr>
                <th>ID</th>
                <th>쿠폰명</th>
                <th>할인방식</th>
                <th>할인값</th>
                <th>최소주문금액</th>
                <th>발급수량</th>
                <th>사용수량</th>
                <th>상태</th>
                <th>관리</th>
              </tr>
            </thead>
  
            <tbody>
              {coupons.length === 0 ? (
                <tr>
                  <td colSpan="9" className="text-center">
                    등록된 쿠폰이 없습니다.
                  </td>
                </tr>
              ) : (
                coupons.map(coupon => {
  
                  const now = new Date();
  
                  const startDate = coupon.start_date
                    ? new Date(coupon.start_date)
                    : null;
  
                  const endDate = coupon.end_date
                    ? new Date(coupon.end_date)
                    : null;
  
                  let status = '사용중';
  
                  if(startDate && now < startDate){
                    status = '대기중';
                  }
  
                  if(endDate && now > endDate){
                    status = '종료';
                  }
  
                  return (
                    <tr key={coupon.id}>
                      <td>{coupon.id}</td>
  
                      <td>{coupon.coupon_name}</td>
  
                      <td>
                        {coupon.discount_type === 'amount'
                          ? '금액할인'
                          : '퍼센트할인'}
                      </td>
  
                      <td>
                        {coupon.discount_type === 'amount'
                          ? `${Number(coupon.discount_value).toLocaleString()}원`
                          : `${coupon.discount_value}%`}
                      </td>
  
                      <td>
                        {Number(
                          coupon.min_order_price || 0
                        ).toLocaleString()}원
                      </td>
  
                      <td>
                        {coupon.issued_count || 0}
                      </td>
  
                      <td>
                        {coupon.used_count || 0}
                      </td>
  
                      <td>{status}</td>
  
                      <td>
                        <button
                          className="btn btn-warning btn-sm me-2"
                          onClick={()=>
                            navigate(`/seller/coupon/edit/${coupon.id}`)
                          }
                        >
                          수정
                        </button>
  
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={()=>
                            deleteCoupon(coupon.id)
                          }
                        >
                          삭제
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
  
        <hr />
  
        <h3>회원 검색</h3>
  
        <input
          className="form-control mb-2"
          placeholder="아이디 또는 닉네임"
          value={keyword}
          onChange={e=>setKeyword(e.target.value)}
        />
  
        <button
          className="btn btn-secondary mb-3"
          onClick={searchMember}
        >
          검색
        </button>
  
        <select
          className="form-select mb-3"
          value={selectedCoupon}
          onChange={e=>setSelectedCoupon(e.target.value)}
        >
          <option value="">
            지급할 쿠폰 선택
          </option>
  
          {coupons.map(c=>(
            <option key={c.id} value={c.id}>
              {c.coupon_name}
            </option>
          ))}
        </select>
  
        <button
          className="btn btn-danger mb-3"
          onClick={issueAll}
        >
          전회원 지급
        </button>
  
        {members.map(member=>(
          <div
            key={member.id}
            className="border p-3 mb-3"
          >
            <div>
              <strong>
                {member.id}
              </strong>
              {' / '}
              {member.nickname}
            </div>
  
            <div className="mt-2">
              {member.coupons?.length > 0 ? (
  
                member.coupons.map(cp=>(
                  <div
                    key={cp.id}
                    className="small text-muted"
                  >
                    {cp.coupon_name}
                    {' '}
                    (
                    {cp.used_yn === 'Y'
                      ? '사용완료'
                      : '미사용'}
                    )
                  </div>
                ))
  
              ) : (
  
                <div className="small text-muted">
                  보유 쿠폰 없음
                </div>
  
              )}
            </div>
  
            <button
              className="btn btn-sm btn-success mt-2"
              onClick={()=>
                issueCoupon(member.id)
              }
            >
              지급
            </button>
          </div>
        ))}
  
      </div>
    </SellerLayout>
  );
};

export default SellerCouponManage;